import { DataListState } from '../data-list.state';
import { ReducerStateFactory } from '../state-factory.reducer';
import { MemberCustomers } from './member-customers.actions';
import { CustomerDto } from '@careapp-group/ng-sdk';

class MemberCustomersReducer extends ReducerStateFactory<CustomerDto[]> {
  constructor() {
    super(MemberCustomers);
  }

  reducer(state: DataListState<CustomerDto[]> = this.initialState, action: any) {
    switch (action.type) {
      case MemberCustomers.REQUEST_REMOVE_MEMBER_FROM_CUSTOMER: {
        const typedAction: { payload: { memberId: string; customerId: string } } = <any>action;
        const { memberId, customerId } = typedAction.payload;

        const paginators = {
          ...state.paginators,
          [memberId]: {
            ...state.paginators[memberId],
            ids: (state.paginators[memberId].ids ?? []).filter((value) => value !== customerId),
          },
        };

        return {
          ...state,
          paginators,
        };
      }
    }
    return super.reducer(state, action);
  }
}

export const state = new MemberCustomersReducer();

export const getEntities = (state: any) => state.entities;

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
